import { render, staticRenderFns } from "./MoneyOrRule.vue?vue&type=template&id=14364014&scoped=true"
import script from "./MoneyOrRule.vue?vue&type=script&lang=js"
export * from "./MoneyOrRule.vue?vue&type=script&lang=js"
import style0 from "./MoneyOrRule.vue?vue&type=style&index=0&id=14364014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14364014",
  null
  
)

export default component.exports